// extracted by mini-css-extract-plugin
export default {"container":"joinBrands--container--cVmYdO7M","description":"joinBrands--description--yMSAX0KS","title":"joinBrands--title--EI_tGB7O"};